import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { NoticeBar, Toast, Swipe, SwipeItem, Dialog, Progress } from "vant";
import axios from "axios";
// import cookie from 'js-cookie'
import date from "./util/dateformat";
import qrcode from 'jr-qrcode'
let ClipBoard = require("clipboard");
let Base64 = require("js-base64").Base64;
import wx from "weixin-js-sdk";
import config from '@/config';
import df from "@/util/dateformat.js";

Vue.use(Progress);
Vue.use(NoticeBar)
  .use(Swipe)
  .use(SwipeItem);
Vue.use(Dialog);
Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.$Toast = Toast;
Vue.prototype.$qrcode = qrcode

//当前登录的用户
Vue.prototype.userInfo = {};
//活动ID。1049是3.0的活动ID，之后拿到这个参数后再改
Vue.prototype.activityId = 126566;
// ****！！！是否是开发版，上线时改成0！！！****
Vue.prototype.isdev = 0;
//接口的服务器地址
Vue.prototype.baseurl = "https://backend.jegotrip.com.cn";
Vue.prototype.baseurl2 = "https://app.jegotrip.com.cn";
// Vue.prototype.baseurl = "https://jegotrip.qungouda.cn";
// Vue.prototype.baseurl = "https://jegotrip.tmmquan.com";
// Vue.prototype.baseurl2 = "https://test01.jegotrip.com.cn";
// Vue.prototype.baseurl = "http://183.239.166.139:7000"

Vue.prototype.appurl = "";
//临时使用的token，经常要更换的，测试用
Vue.prototype.token = "";
Vue.prototype.sessionkey = "";
Vue.prototype.version = "***v1.1.8***";
Vue.prototype.configInfo = null;
Vue.prototype.hideShare = 0;
Vue.prototype.pageId = 'pray';
// 活动信息
Vue.prototype.activityInfo = null;
// 许愿总数
Vue.prototype.wishTotal = 0;
Vue.prototype.myUserInfo = null
//时间格式化
Vue.prototype.dateformat = date.formatdate;
//埋点统计
// Vue.prototype._deepmain = function (deepid, point, deeptype, callback) {
//   var t = this;
//   var uri_ =
//     "https://app-product.cn-hongkong.log.aliyuncs.com/logstores/activity_h5/track";
//   var params_ = {};
//   // 获取当前时间
//   function p(s) {
//     return s < 10 ? "0" + s : s;
//   }
//   var myDate = new Date();
//   var year = myDate.getFullYear(); // 获取当前年
//   var month = myDate.getMonth() + 1; // 获取当前月
//   var date = myDate.getDate(); // 获取当前日
//   var h = myDate.getHours(); // 获取当前小时数(0-23)
//   var m = myDate.getMinutes(); // 获取当前分钟数(0-59)
//   var s = myDate.getSeconds();
//   var now =
//     year +
//     "-" +
//     p(month) +
//     "-" +
//     p(date) +
//     " " +
//     p(h) +
//     ":" +
//     p(m) +
//     ":" +
//     p(s);
//   // 获取当前页面地址
//   var hwurl = encodeURIComponent(location.href);
//   var pageId = deepid;
//   // t.configInfo && t.configInfo.pageId ? t.configInfo.pageId : deepid;
//   params_.APIVersion = "0.6.0"; // 埋点 - 时间
//   params_.dtEventTime = now; // 埋点 - 时间
//   params_.vUrl = hwurl; // 埋点 - H5链接
//   params_.iSourceId = "3"; // 埋点 - 来源系统  3.web
//   params_.H5Title = "H5"; // 埋点 - 标题
//   params_.vPageId = pageId; // 埋点 - Deeplink名称,pageid页面id
//   params_.vFunctionId = pageId + '#' + point; // 埋点 - 查询关键字
//   params_.iDoType = deeptype; // 埋点 - 动作
//   params_.vChannel = this._getAPPParams().channel;
//   this.$http.get(uri_, { params: params_ }).then(function () {
//     console.log('埋点成功，params_:', params_)
//     typeof callback == "function" && callback();
//   }).catch(error => {
//     typeof callback == "function" && callback(error);
//   });
// };
//埋点统计-新埋点2020.01.21
Vue.prototype._deepmain = function (deepid, point, deeptype, callback, vPara) {
  var t = this;
  var uri_ =
    "https://app-product.cn-hongkong.log.aliyuncs.com/logstores/activity_h5/track";
  var params_ = {};
  // 获取当前时间
  function p(s) {
    return s < 10 ? "0" + s : s;
  }
  var myDate = new Date();
  var year = myDate.getFullYear(); // 获取当前年
  var month = myDate.getMonth() + 1; // 获取当前月
  var date = myDate.getDate(); // 获取当前日
  var h = myDate.getHours(); // 获取当前小时数(0-23)
  var m = myDate.getMinutes(); // 获取当前分钟数(0-59)
  var s = myDate.getSeconds();
  var now =
    year +
    "-" +
    p(month) +
    "-" +
    p(date) +
    " " +
    p(h) +
    ":" +
    p(m) +
    ":" +
    p(s);
  // 获取当前页面地址
  var hwurl = encodeURIComponent(location.href);

  var pageId = t.pageId ;
  params_.APIVersion = "0.6.0"; // 埋点 - 时间
  params_.dtEventTime = now; // 埋点 - 时间
  params_.vUrl = hwurl; // 埋点 - H5链接
  params_.iSourceId = "3"; // 埋点 - 来源系统  3.web
  params_.H5Title = "H5"; // 埋点 - 标题
  params_.vPageId = pageId; // 埋点 - Deeplink名称,pageid页面id
  params_.vFunctionId = pageId + '#' + point; // 埋点 - 查询关键字
  params_.iDoType = deeptype; // 埋点 - 动作

  params_.iUserId = localStorage.getItem("iUserId") || ''; //无忧行ID userId
  params_.vPhoneMacId = "3"; //设备ID
  params_.vid = localStorage.getItem("vid") || '';  //用户唯一标识:H5，浏览器指纹ID；小程序，使用openid
  params_.vPara = vPara || ''; //功能参数
  params_.vProject = t._getAPPParams().vProject || '';  // 项目:用户一级来源，取url上vProject对应的值
  params_.vChannel = t._getAPPParams().vChannel || ''; //渠道
  params_.vActivityId = t._getAPPParams().vActivityId || '';  // H5页面关联的活动id:在CRM创建活动时生成的活动id，取url上vActivityId对应的值
  params_.vActivityName = t._getAPPParams().vActivityName || '';  // H5页面关联的活动名称:取url上vActivityName对应的值
  console.log('当前埋点参数',params_);

  this.$http.get(uri_, { params: params_ }).then(function () {
    typeof callback == "function" && callback();
  }).catch(error => {
    typeof callback == "function" && callback(error);
  });
};
//跳转到下载app界面
Vue.prototype._downloadAPP = function (ism, productCode) {
  var t = this;
  console.log('_downloadAPP productCode')
  console.log(productCode)
  if (!ism) {
    window.location.href =
      "https://a.app.qq.com/o/simple.jsp?pkgname=com.cmi.jegotrip";
    return false;
  }
  var clipboard = new ClipBoard(".btn-clipboard", {
    text: function (trigger) {
      // console.log(trigger)
      // console.log(trigger.getAttribute("data-id"))
      console.log("trigger.id ", trigger.id);
      // var url = window.location.href;
      // var url2 = url.substring(0, url.lastIndexOf("#"));
      // if (url.lastIndexOf("#") < 0) {
      //   url2 = url
      // }
      // if (url2.lastIndexOf("?") < 0) {
      //   url2 = url2 + '?jtpnav=1&islogin=1#/'
      // } else if (url2.lastIndexOf("islogin=1") < 0) {
      //   url2 = url2 + '&jtpnav=1&islogin=1#/'
      // }
      var initurl = t._getInitUrl();

      var url2 = `${initurl.roothref}index.html?a=${t._getAPPParams().activity_id}&cid=${t._getAPPParams().cid}`;


      if (ism == 2) {
        url2 = url2 + '#/'
      } else {
        url2 = url2 + '#/'
      }
      console.log('当前url2:')
      console.log(url2)
      var content = "";
      if (trigger.id == "btnH5" || trigger.id == "btnH5D1") {
        content = makeUrl(
          "h5Nav",
          "祈福武汉",
          "祈福武汉",
          url2,
          ""
        );
      } else if (trigger.id == "btnNA") {
        content = makeUrl(
          "native",
          "我是原生的title",
          "我是原生的描述",
          "cellularinfo",
          { countryCode: "66", countryName: "泰国", netType: "4G" }
        );
      } else if (trigger.id == "btnRN") {
        console.log('productCode:', productCode)
        if (productCode) {
          content = makeUrl(
            "rn",
            "无忧行爆款返场",
            "精选商品，正限时特价抢购中！",
            "malldetail",
            { productCode: productCode }
          );
        } else {
          content = makeUrl(
            "rn",
            (t.configInfo && t.configInfo.dialogTitle ? t.configInfo.dialogTitle : "祈福武汉"),
            (t.configInfo && t.configInfo.dialogSubhead ? t.configInfo.dialogSubhead : "祈福武汉"),
            "memberbenefits",
            { islogin: 1 }
          );
        }

      }
      return content;
    }
  });

  // var clipboard = new ClipboardJS('.btn');
  clipboard.on("success", function (e) {
    t._deepmain(t.pageId, productCode, 2, function () {
      var appand = "https://at.umtrack.com/eKr41n";
      var appios = "https://at.umtrack.com/DmC8ji";
      // 国际漫游公众号gjmygzh0117,不带logo
      if (t._getAPPParams().channel == 'gjmygzh0117') {
        appand = "https://at.umtrack.com/onelink/SLvmya";
        appios = appand;
      }
      // 泊寓渠道参数：by0110，带logo；
      if (t._getAPPParams().channel == 'by0117') {
        appand = "https://at.umtrack.com/onelink/19nq4f";
        appios = appand;
      }
      // 无忧行公众号，渠道参数：wyxgzh0117，不带logo；
      if (t._getAPPParams().channel == 'wyxgzh0117') {
        appand = "https://at.umtrack.com/onelink/4D0Due";
        appios = appand;
      }
      // 拇指公园：，渠道参数：mzgy0110，不带logo；
      if (t._getAPPParams().channel == 'mzgy0117') {
        appand = "https://at.umtrack.com/onelink/qSDC8f";
        appios = appand;
      }
      //无忧行app主链接：，渠道参数：wyx0117，不带logo；
      if (t._getAPPParams().channel == 'wyx0117') {
        appand = "https://at.umtrack.com/onelink/iiKXrC";
        appios = appand;
      }
      var url = [
        appand,
        appios,
        "https://www.jegotrip.com/",
        "jegotrip://deeplink?title=&describe=1&url=" +
        encodeURIComponent(window.location.href)
      ];

      function checkOs() {
        var ua = navigator.userAgent;
        if (ua.match(/android/i)) {
          // 安卓
          return 0;
        } else if (ua.match(/(iPhone|iPod|iPad);?/i)) {
          // IOS
          return 1;
        } else {
          // 其它
          return 2;
        }
      }
      var OS = checkOs(),
        urls = url;
      var clickedAt = +new Date();
      //    window.location = urls[3];

      var wxua = window.navigator.userAgent.toLowerCase();
      // console.log("wxua",wxua)
      if (wxua.match(/MicroMessenger/i) == "micromessenger") {
        // 微信 - 下载跳转
        window.location = urls[OS];
      } else {
        // 非微信 - 下载跳转
        setTimeout(function () {
          !window.document.webkitHidden &&
            setTimeout(function () {
              if (+new Date() - clickedAt < 2000) {
                window.location = urls[OS];
              }
            }, 500);
        }, 1000);
      }
    })
  });
  function makeUrl(type, title, desc, url, param) {
    var obj = {
      type: type,
      title: title,
      describe: desc,
      url: url,
      param: param
    };
    return (
      "jegotrip://deeplink?json=" + encodeURIComponent(JSON.stringify(obj))
    );
  }

};
Vue.prototype._testbase64 = function (str) {
  return Base64.encode(str);
};
//分享一个链接
Vue.prototype._sharelink = function (shareInfo) {
  var t = this;
  var userid = 0;
  var app_login_user = localStorage.getItem(config.login_key);
  console.log("sharelink:app_login_user");
  console.log(app_login_user);
  if (app_login_user) app_login_user = JSON.parse(app_login_user);
  if (app_login_user.userid) {
    // userid = app_login_user.userid;
  }
  // var title = t.configInfo && t.configInfo.shareTitle ? t.configInfo.shareTitle : "2020年旅游星愿就要。。了，快来帮我祝个福";
  // shareText: t.configInfo && t.configInfo.shareDesc ? t.configInfo.shareDesc : "我在无忧行参加旅行星愿活动，你愿意和我一起去旅行嘛？",
  // shareImg: t.configInfo && t.configInfo.shareCover ? t.configInfo.shareCover : `${initurl.roothref}icon_share.jpg`,
  var title = "祈福武汉，为中国加油";
  // if (t.myUserInfo && t.myUserInfo.isbindtel == 1 && t.myUserInfo.nickname) {
  //   title = t.myUserInfo.nickname + '的' + title;
  // }
  var initurl = t._getInitUrl();

  var myurl = `${initurl.roothref}index.html#/?a=${t._getAPPParams().activity_id}&sid=${userid}&channel=${t._getAPPParams().channel}&cid=${t._getAPPParams().cid}&isauth=1`;

  if (!shareInfo) {
    shareInfo = {
      shareTitle: title,
      shareText: "我在这儿，为抗疫出一份力？",
      shareImg: `${initurl.roothref}icon_share.jpg`,
      wechatLink: myurl,
      weiboLink: myurl
    };
  }
  if (!shareInfo || !shareInfo.shareTitle || !shareInfo.shareText) {
    t.$Toast("网络不给力，请稍后再试");
    return false;
  }
  var href =
    `/appInvite?title=${encodeURIComponent(
      shareInfo.shareTitle
    )}&desc=${encodeURIComponent(shareInfo.shareText)}&imageUrl=${
    shareInfo.shareImg
    }&weiboLink=${Base64.encode(
      shareInfo.weiboLink
    )}&wechatLink=${Base64.encode(shareInfo.wechatLink)}&d=` +
    new Date().valueOf();
  console.log("href", href);
  window.location.href = href;
};
// 获取活动信息配置
Vue.prototype._activityConfig = function (callback) {
  var t = this;
  if (!t._getAPPParams().cid) {
    callback('没有cid')
    return false;
  }
  var loading = t.$Toast.loading({
    duration: 0, // 持续展示 toast
    forbidClick: true, // 禁用背景点击
    mask: true,
    message: "加载中..."
  });
  var apiurl = `${t.baseurl2}/api/atv/v1/config/${t._getAPPParams().cid}`;
  var params = {};
  t.$http
    .post(apiurl, params)
    .then(res => {
      console.log('获取活动信息配置')
      console.log(`${apiurl},params:`, params);
      console.log(`${apiurl},res:`, res);
      loading.clear();
      if (res.data.code == 0) {
        var ui = res.data.body.ui;
        if (!ui || ui.length <= 0) {
          return false;
        }
        var obj = {}
        for (var i = 0; i < ui.length; i++) {
          obj[ui[i].key] = ui[i].value;
        }
        console.log('configInfo:', obj)
        Vue.prototype.configInfo = obj;
        callback(null, obj);
      } else {
        callback(res.data.msg);
        // t.$toast(res.data.msg);
      }
    })
    .catch(error => {
      // console.log(error);
      callback(error);
    })
    .finally(() => {
      loading.clear();
    });
};

// 获取用户信息
Vue.prototype._getUser = function (callback) {
  var t = this;
  // if (Vue.prototype.myUserInfo) {
  //   callback(null, Vue.prototype.myUserInfo);
  //   return false;
  // }
  var params = {
    rec_uid: t._getAPPParams().share_userid,
    activity_id: t._getAPPParams().activity_id
  };
  t._signup("user", "User.getUserInfo", params)
    .then(res => {
      if (res.status == 0) {
        var myuser = res.data.user;
        Vue.prototype.myUserInfo = myuser;
        // if (myuser.isbindtel == 1) {
        //   var app_login_user = localStorage.getItem(config.login_key);
        //   if (app_login_user) {
        //     app_login_user = JSON.parse(app_login_user);
        //     app_login_user.userid = myuser.uid;
        //     localStorage.setItem(
        //       config.login_key,
        //       JSON.stringify(app_login_user)
        //     );
        //     if (t._getBrowser() == 2) {
        //       console.log("_getUser t._wxReadySuccessFun");
        //       t._wxReadySuccessFun();
        //     }
        //   }
        // }

        callback(null, Vue.prototype.myUserInfo);
      } else {
        callback(res.msg);
      }
    })
    .catch(error => {
      console.log(`error:${error}`);
    });
},

  //获得顶部随机的中奖信息
  Vue.prototype._getLucks = function (activityLucks) {
    var result = [];
    var bPhones = "133/153/180/181/189/177/130/131/132/155/156/185/186/145/176/134/135/136/137/138/139/150/151/152/157/158/159/182/183/184/187/188/147/178".split(
      "/"
    );
    // console.log("bPhones", bPhones);
    const randomInt = (min, max) => Math.floor(Math.random() * (max - min) + min);
    for (var i = 0; i < 10; i++) {
      var luckIndex = randomInt(0, activityLucks.length - 1);
      var ePhone = `${bPhones[randomInt(0, bPhones.length - 1)]}****${randomInt(
        1111,
        9999
      )}`;
      var lucks_ = activityLucks[luckIndex].award_name;

      result.push(
        {
          user_tel: ePhone,
          award_name: lucks_
        }
      );
    }
    return result;
  };
//获得活动的信息
Vue.prototype._getActivityInfo = function () {
  var t = this;
  // var loading = t.$Toast.loading({
  //   duration: 0, // 持续展示 toast
  //   forbidClick: true, // 禁用背景点击
  //   mask: true,
  //   message: "加载中..."
  // });
  return new Promise(function (resolve, reject) {
    var params = {
      activity_id: t._getAPPParams().activity_id
    };
    console.log(`Activity.getActivityInfo，params：`, params);
    t._commonApi("activity", "Activity.getActivityInfo", params)
      .then(res => {
        // loading.clear();
        if (res.status == 0) {
          console.log("activity info",res)
          Vue.prototype.wishTotal = res.data.total_num;
          if(res.data.isopen != 1){
            t.$dialog.alert({
              title: "温馨提示",
              message: "活动已下线",
              confirmButtonText: '好的'
            }).then(() => {
              
            });
          }
          // var info = res.data;
          // console.log(JSON.parse(JSON.stringify(info.award_list)));
          // var a = Date.parse(new Date(res.Data.coupon_expdate));
          // info.start_time_format = df.formatdate(
          //   "Y/m/d",
          //   info.start_time * 1000
          // );
          // info.end_time_format = df.formatdate(
          //   "Y/m/d",
          //   info.end_time * 1000
          // );
          // var nowtime = new Date().valueOf();
          // console.log(nowtime);
          // console.log(info.start_time * 1000);
          // console.log(info.end_time * 1000);
          // if (
          //   nowtime < info.start_time * 1000 ||
          //   nowtime > info.end_time * 1000
          // ) {
          //   info.isover = true;

          // } else {
          //   info.isover = false;
          // }
          // // info.rule_desc = info.rule_desc.replace(/[\d]+[\.\、]+/g, "");
          // info.rule_desc = info.rule_desc.split("\n");
          // console.log("####LU:activityInfo", info);
          Vue.prototype.activityInfo = res.data;
          
          resolve(res.data);
          // var pageId =
          //   t.configInfo && t.configInfo.pageId
          //     ? t.configInfo.pageId
          //     : "mjtt";
          // t._deepmain(pageId, `${pageId}#h5open1`, 0);
        } else {
          t.$Toast(res.msg)
          reject(res.msg);
        }
      })
      .catch(error => {
        // loading.clear();
        reject(error);
        console.log(`error:${error}`);
      });
  });
};
Vue.prototype.login_exp = function () {
  var t = this;
  // t.$Toast('您的授权已经过期，正在重新授权！')
  // setTimeout(function () {
  //   localStorage.removeItem(config.login_key);
  //   window.location();
  // }, 2000)
  t.$dialog.alert({
    title: "温馨提示",
    message: "您的授权已经过期，请在刷新页面后重试",
    confirmButtonText: '刷新页面'
  }).then(() => {
    localStorage.removeItem(config.login_key);
    window.location.reload();
  });

};

//请求地址
// 现网
var prefix = "/wyx_via_plus/index.php?";
if (Vue.prototype.isdev == 1) {
  prefix = "/index.php?";
}
// 活动的类型，记录是哪个项目的
var via_atype = 'via_pray';
Vue.prototype._ReParams = function (params) {
  var t = this;
  console.log("ReParams")
  if (!params) params = {};
  params.activity_id = t._getAPPParams().activity_id;
  return params;
}

Vue.prototype._get = function (v, r, params = {}) {
  var t = this;
  params = t._ReParams(params);
  return new Promise((resolve, reject) => {
    var app_login_user = localStorage.getItem(config.login_key);
    console.log(config.login_key);
    console.log(app_login_user);
    console.log(JSON.parse(app_login_user));
    if (app_login_user) {
      try {
        app_login_user = JSON.parse(app_login_user);
      } catch (e) { }
      console.log(config.login_key);
      console.log(app_login_user.sessionkey);
      var url = t.baseurl + prefix + 'v=' + v + '&r=' + r + '&addon=' + via_atype
      params.role = "user";
      params.sessionkey = app_login_user.sessionkey; //这里后面换成从cookies取 取了替换
      // params.sessionkey = t.sessionkey;
      var loading = null;
      setTimeout(() => {
        if (!loading)
          loading = t.$Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            mask: true,
            message: "加载中..."
          });
      }, 200);
      console.log(`${url},params：`, params);
      axios.get(url, { params }).then(
        res => {
          console.log(`${url},res:`);
          console.log(res.data);
          console.log(res)
          if (res.status == 200) {
            if (res.data.status == 20002 || res.data.status == 50001 ||res.data.status == 50003) t.login_exp();
            else resolve(res.data);
          } else {
            reject(res.statusText ? res.statusText : '网络错误');
          }
          if (loading) loading.clear();
          loading = 'stop'
        },
        rej => {
          console.log(`${url},${params},error:${rej}`);
          console.log(rej);
          reject(rej);
          if (loading) loading.clear();
          loading = 'stop'
        }
      );
    } else t.login_exp();
  });
};
Vue.prototype._post = function (v, r, params = {}) {
  var t = this;
  params = t._ReParams(params);
  return new Promise((resolve, reject) => {
    var app_login_user = localStorage.getItem(config.login_key);
    if (app_login_user) {
      app_login_user = JSON.parse(app_login_user);
      var url = t.baseurl + prefix + 'v=' + v + '&r=' + r + '&addon=' + via_atype
      params.role = "user";
      params.sessionkey = app_login_user.sessionkey; //这里后面换成从cookies取 取了替换
      // params.sessionkey = t.sessionkey;
      var loading = null;
      setTimeout(() => {
        if (!loading)
          loading = t.$Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            mask: true,
            message: "加载中..."
          });
      }, 200);
      console.log(`${url},params：`);
      console.log(`${params}`);
      axios.post(url, { params }).then(
        res => {
          console.log(`${url},res:`);
          console.log(res.data);
          if (res.status == 200) {
            if (res.data.status == 20002 || res.data.status == 50001 ||res.data.status == 50003) t.login_exp();
            else resolve(res.data);
          } else {
            reject(res.statusText);
          }
          if (loading) loading.clear();
          loading = 'stop'
        },
        rej => {
          reject(rej);
          if (loading) loading.clear();
          loading = 'stop'
        }
      );
    } else t.login_exp();
  });
};

// 后台登录注册
Vue.prototype._signup = function (v, r, params = {}) {
  var t = this;
  params = t._ReParams(params);
  return new Promise((resolve, reject) => {
    var app_login_user = localStorage.getItem(config.login_key);
    if (app_login_user) {
      try {
        app_login_user = JSON.parse(app_login_user);
      } catch (e) { }
      var url = t.baseurl + prefix + 'v=' + v + '&r=' + r + '&addon=' + via_atype
      params.role = "user";
      params.sessionkey = app_login_user.sessionkey; //这里后面换成从cookies取 取了替换
      // params.sessionkey = t.sessionkey;
      var loading = null;
      setTimeout(() => {
        if (!loading)
          loading = t.$Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            mask: true,
            message: "加载中..."
          });
      }, 200);
      console.log(`${url},params：`, params);
      console.log(`${params}`);
      axios.get(url, { params }).then(
        res => {
          console.log(`${url},res:`);
          console.log(res.data);
          console.log(res.data);
          if (res.status == 200) {
            if (res.data.status == 20002 || res.data.status == 50001 ||res.data.status == 50003) t.login_exp();
            else resolve(res.data);
          } else {
            reject(res.statusText ? res.statusText : '网络错误');
          }
          if (loading) loading.clear();
          loading = 'stop'
        },
        rej => {
          console.log(`${url},${params},error:${rej}`);
          console.log(rej);
          reject(rej);
          if (loading) loading.clear();
          loading = 'stop'
        }
      );
    } else t.login_exp();
  });
};

Vue.prototype._commonApi = function (v, r, params = {}) {
  var t = this;
  params = t._ReParams(params);
  return new Promise((resolve, reject) => {
    var url = t.baseurl + prefix + 'v=' + v + '&r=' + r + '&addon=' + via_atype;
    params.role = "common";
    var loading = null;
    setTimeout(() => {
      if (!loading)
        loading = t.$Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true, // 禁用背景点击
          mask: true,
          message: "加载中..."
        });
    }, 200);
    console.log(`${url} params`, params);
    axios.post(url, params).then(
      res => {
        console.log(`${url} res`, res);
        if (res.status == 200) {
          resolve(res.data);
        } else {
          reject(res.statusText ? res.statusText : '网络错误');
        }
        if (loading) loading.clear();
        loading = 'stop'
      },
      rej => {
        reject(rej);
        console.log(rej);
        if (loading) loading.clear();
        loading = 'stop'
      }
    );
  });
};

Vue.prototype._keyUrl = function () {
  var items = [];
  var url = location.href;
  if (url === undefined || typeof url != "string") {
    return null;
  }
  var json = {};
  var newurl = url.split("#")[0];
  var arr = newurl.split("?");
  if (arr.length > 1) {
    items = arr[1].split("&");
    for (var i = 0; i < items.length; i += 1) {
      var item = items[i].split("=");
      json[item[0]] = item[1];
    }
  }
  return json;
};
Vue.prototype._wxReadySuccessFun = function () {
  var t = this;
  var userid = 0;
  // var app_login_user = localStorage.getItem(config.login_key);
  // console.log("app:app_login_user");
  // console.log(app_login_user);
  // if (app_login_user) app_login_user = JSON.parse(app_login_user);
  // if (app_login_user && app_login_user.userid) {
  //   userid = app_login_user.userid;
  // }
  var title = "祈福武汉，为中国加油";
  if (t.myUserInfo && t.myUserInfo.isbindtel == 1 && t.myUserInfo.nickname) {
    title = t.myUserInfo.nickname + title;
  }
  var initurl = t._getInitUrl();

  // var myurl = `${initurl.href}?a=${
  //   initurl.urldata.a ? initurl.urldata.a : 2
  // }&sid=${userid}&isauth=1`;
  var myurl = `${initurl.roothref}index.html#/?a=${t._getAPPParams().activity_id}&sid=${userid}&channel=${t._getAPPParams().channel}&cid=${t._getAPPParams().cid}&isauth=1`;

  var share_params = {
    title: title,
    link: myurl,
    // imgUrl:"http://test01.jegotrip.com.cn/wyx/appwap/images/logoWhite.png",
    imgUrl: `${initurl.roothref}icon_share.jpg`
  };
  console.log("share_params", share_params);
  wx.updateAppMessageShareData({
    title: share_params.title, // 分享标题
    link: share_params.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    desc: "我在这儿，为抗疫出一份力", // 分享描述
    imgUrl: share_params.imgUrl, // 分享图标
    success: function () {
      // 设置成功
      console.log("updateAppMessageShareData success ");
    },
    fail: function (res) {
      console.log("updateAppMessageShareData fail ", res);
    }
  });
  wx.updateTimelineShareData({
    title: share_params.title, // 分享标题
    link: share_params.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: share_params.imgUrl, // 分享图标
    success: function () {
      // 设置成功
      console.log("updateTimelineShareData success ");
    },
    fail: function (res) {
      console.log("updateTimelineShareData fail ", res);
    }
  });
};

Vue.prototype._InitUrl = null;
//获得项目首次加载时（进入App.vue）的项目根目录
Vue.prototype._getInitUrl = function () {
  var t = this;
  var urlData = t._keyUrl();
  console.log("window.location", window.location);
  var q = t.$route.query;
  if (q.a) {
    urlData = q;
  }
  if (!t._InitUrl || t._InitUrl.href == "") {
    // var url = window.location.href;
    // var url2 = "",url3 = "";
    // if (url.indexOf("?") >= 0) {
    //   url2 = url.substring(0, url.indexOf("?"));
    // }
    Vue.prototype._InitUrl = {
      href: window.location.href.split("?")[0],
      urldata: urlData,
      roothref: `${window.location.origin}${window.location.pathname.substr(
        0,
        window.location.pathname.lastIndexOf("/") + 1
      )}`
    };
  }
  console.log("now initurl", t._InitUrl);
  return t._InitUrl;
};
//获得通用的APP参数
Vue.prototype._getAPPParams = function () {
  console.log("now app params load");
  var result = {
    share_userid: 0,
    activity_id: config.default_aid,
    cid: 0,
    vChannel: "",
    vProject: "",
    vActivityId: "",
    vActivityName: ""
  };
  var app_params = localStorage.getItem(config.app_params_key);
  if (app_params) app_params = JSON.parse(app_params);
  if (app_params && Object.keys(app_params).length > 0) {
    result = app_params;
    console.log("now app localstorage params", result);
  }
  else console.log("now app default params", result);
  return result;
};
//获得微信sdk配置
Vue.prototype._getJSConfig = function () {
  var t = this;
  console.log("getjsconfig t.urldata", t.urlData);
  // var url = window.location.href;
  // var url2 = "",
  //   url3 = "";
  // if (url.indexOf("?") >= 0) {
  //   url2 = url.substring(0, url.indexOf("?"));
  // }
  // if (url.lastIndexOf("#") >= 0) {
  //   url3 = url.substring(0, url.lastIndexOf("#"));
  // }
  var initurl = t._getInitUrl();
  console.log("initurl", initurl);
  var apilist = ["updateAppMessageShareData", "updateTimelineShareData"];
  // 记录进入app时的url
  if (typeof window.entryUrl === "undefined" || window.entryUrl === "") {
    window.entryUrl = location.href.split("#")[0];
  }
  // 进行签名的时候  Android 不用使用之前的链接， ios 需要
  let signLink = /(Android)/i.test(navigator.userAgent)
    ? location.href.split("#")[0]
    : window.entryUrl;
  var params = {
    js_config: {
      jsApiUrl: signLink,
      jsApiList: apilist
    }
  };

  t._commonApi("signup", "SignUp.getJSConfig", params)
    .then(res => {
      console.log("***微信sdk配置***");
      if (res.status == 0 && res.data && res.data.code == "0") {
        var res = res.data.body;
        wx.config({
          debug: false, // 开启调试模式,
          appId: res.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.nonceStr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名，见附录1
          jsApiList: apilist // 必填，需要使用的JS接口列表，所有JS接口列表见附录2 scanQRCode
        });
        // var shareInfo = t.shareInfo;
        // var title = shareInfo.shareTitle ? encodeURIComponent(shareInfo.shareTitle) : '无忧行邀您组队瓜分百分红包'
        wx.ready(function () {
          // t.wx_success = 1;
          console.log("wxsdk success");
          // 因为app.vue会先执行，_getUser需要登录才可以调用，所以先判断是否有登录信息了
          var app_login_user = localStorage.getItem(config.login_key);
          // if (app_login_user) {
          //   // 如果绑定了就存好userid
          //   t._getUser(function () { });
          // } else {
            t._wxReadySuccessFun();
          // }

        });
        wx.error(function (res) {
          console.log("wxsdk error", res);
          // t.wx_success = 0;
          // Toast("扫码组件加载失败，请刷新后重试");
        });
      }
    })
    .catch(error => {
      console.log(`error:${error}`);
    });

};
//获得通用的APP参数
Vue.prototype._getBrowser = function () {
  var result = 0;
  var userAgent = window.navigator.userAgent.toLowerCase();
  if (userAgent.match(/jegotrip/i) == "jegotrip") result = 1;
  else if (userAgent.match(/micromessenger/i) == "micromessenger") result = 2;
  return result;
};
//获取登录信息
Vue.prototype._getLoginInfo = function () {
  var app_login_user = localStorage.getItem(config.login_key);
  if (app_login_user) app_login_user = JSON.parse(app_login_user);
  return app_login_user;
}
// //删除登录信息，跳转登录页面重新登录
// Vue.prototype._reloadLogin = function(){
//   localStorage.removeItem(config.login_key);
//   router.push({
//     path: "/login",
//     query: {}
//   });
// }
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
